module.exports = __webpack_public_path__ + "img/australian-country.1cbf0ccc.png";